import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { TranslatePipe } from 'app/core/i18n/translate.pipe';
import { OfficeChangeConfirmDialogData } from '../../interfaces/dialog-data.interface';

@Component({
  selector: 'app-office-change-confirm-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, TranslatePipe],
  templateUrl: './office-change-confirm-modal.component.html',
})
export class OfficeChangeConfirmModalComponent {
  constructor(
    private dialogRef: MatDialogRef<OfficeChangeConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OfficeChangeConfirmDialogData
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
